function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import memoize from 'lodash/memoize';
import uniqueId from 'lodash/uniqueId';
import { v4 as uuid } from 'uuid';
import { ListField, ListFieldItem } from 'decap-cms-ui-next';
import { stringTemplate, validations } from 'decap-cms-lib-widgets';
import { TYPES_KEY, getTypedFieldForValue, resolveFieldKeyType, getErrorMessageForTypedFieldAndValue } from './typedListHelpers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const valueTypes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  MIXED: 'MIXED'
};
function handleSummary(summary, entry, label, item) {
  const data = stringTemplate.addFileTemplateFields(entry.get('path'), item.set('fields.label', label));
  return stringTemplate.compileStringTemplate(summary, null, '', data);
}
function validateItem(field, item) {
  if (!Map.isMap(item)) {
    console.warn(`'${field.get('name')}' field item value value should be a map but is a '${typeof item}'`);
    return false;
  }
  return true;
}
export default class ListControl extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "childRefs", {});
    _defineProperty(this, "valueToString", value => {
      let stringValue;
      if (List.isList(value) || Array.isArray(value)) {
        stringValue = value.join(',');
      } else {
        console.warn(`Expected List value to be an array but received '${value}' with type of '${typeof value}'. Please check the value provided to the '${this.props.field.get('name')}' field`);
        stringValue = String(value);
      }
      return stringValue.replace(/,([^\s]|$)/g, ', $1');
    });
    _defineProperty(this, "getValueType", () => {
      const {
        field
      } = this.props;
      if (field.get('fields')) {
        return valueTypes.MULTIPLE;
      } else if (field.get('field')) {
        return valueTypes.SINGLE;
      } else if (field.get(TYPES_KEY)) {
        return valueTypes.MIXED;
      } else {
        return null;
      }
    });
    _defineProperty(this, "uniqueFieldId", uniqueId(`${this.props.field.get('name')}-field-`));
    _defineProperty(this, "handleChange", e => {
      const {
        onChange
      } = this.props;
      const oldValue = this.state.value;
      const newValue = e.target.value.trim();
      const listValue = newValue ? newValue.split(',') : [];
      if (newValue.match(/,$/) && oldValue.match(/, $/)) {
        listValue.pop();
      }
      const parsedValue = this.valueToString(listValue);
      this.setState({
        value: parsedValue
      });
      onChange(List(listValue.map(val => val.trim())));
    });
    _defineProperty(this, "handleFocus", () => {
      this.props.setActiveStyle();
    });
    _defineProperty(this, "handleBlur", e => {
      const listValue = e.target.value.split(',').map(el => el.trim()).filter(el => el);
      this.setState({
        value: this.valueToString(listValue)
      });
      this.props.setInactiveStyle();
    });
    _defineProperty(this, "handleAdd", e => {
      e.preventDefault();
      const {
        field
      } = this.props;
      const parsedValue = this.getValueType() === valueTypes.SINGLE ? this.singleDefault() : fromJS(this.multipleDefault(field.get('fields')));
      this.addItem(parsedValue);
    });
    _defineProperty(this, "singleDefault", () => {
      return this.props.field.getIn(['field', 'default'], null);
    });
    _defineProperty(this, "multipleDefault", fields => {
      return this.getFieldsDefault(fields);
    });
    _defineProperty(this, "handleAddType", (type, typeKey) => {
      const parsedValue = fromJS(this.mixedDefault(typeKey, type));
      this.addItem(parsedValue);
    });
    _defineProperty(this, "mixedDefault", (typeKey, type) => {
      const selectedType = this.props.field.get(TYPES_KEY).find(f => f.get('name') === type);
      const fields = selectedType.get('fields') || [selectedType.get('field')];
      return this.getFieldsDefault(fields, {
        [typeKey]: type
      });
    });
    _defineProperty(this, "getFieldsDefault", (fields, initialValue = {}) => {
      return fields.reduce((acc, item) => {
        const subfields = item.get('field') || item.get('fields');
        const object = item.get('widget') == 'object';
        const name = item.get('name');
        const defaultValue = item.get('default', null);
        if (List.isList(subfields) && object) {
          const subDefaultValue = this.getFieldsDefault(subfields);
          !isEmpty(subDefaultValue) && (acc[name] = subDefaultValue);
          return acc;
        }
        if (Map.isMap(subfields) && object) {
          const subDefaultValue = this.getFieldsDefault([subfields]);
          !isEmpty(subDefaultValue) && (acc[name] = subDefaultValue);
          return acc;
        }
        if (defaultValue !== null) {
          acc[name] = defaultValue;
        }
        return acc;
      }, initialValue);
    });
    _defineProperty(this, "addItem", parsedValue => {
      const {
        value,
        onChange,
        field
      } = this.props;
      const addToTop = field.get('add_to_top', false);
      const itemKey = uuid();
      this.setState({
        itemsCollapsed: addToTop ? [false, ...this.state.itemsCollapsed] : [...this.state.itemsCollapsed, false],
        keys: addToTop ? [itemKey, ...this.state.keys] : [...this.state.keys, itemKey]
      });
      const listValue = value || List();
      if (addToTop) {
        onChange(listValue.unshift(parsedValue));
      } else {
        onChange(listValue.push(parsedValue));
      }
    });
    _defineProperty(this, "processControlRef", ref => {
      var _this$props$controlRe, _this$props;
      if (!ref) return;
      const {
        props: {
          validationKey: key
        }
      } = ref;
      this.childRefs[key] = ref;
      (_this$props$controlRe = (_this$props = this.props).controlRef) === null || _this$props$controlRe === void 0 || _this$props$controlRe.call(_this$props, this);
    });
    _defineProperty(this, "validate", () => {
      // First validate child widgets if this is a complex list
      const hasChildWidgets = this.getValueType() && Object.keys(this.childRefs).length > 0;
      if (hasChildWidgets) {
        Object.values(this.childRefs).forEach(widget => {
          var _widget$validate;
          widget === null || widget === void 0 || (_widget$validate = widget.validate) === null || _widget$validate === void 0 || _widget$validate.call(widget);
        });
      } else {
        this.props.validate();
      }
      this.props.onValidateObject(this.props.forID, this.validateSize());
    });
    _defineProperty(this, "validateSize", () => {
      const {
        field,
        value,
        t
      } = this.props;
      const min = field.get('min');
      const max = field.get('max');
      const required = field.get('required', true);
      if (!required && !(value !== null && value !== void 0 && value.size)) {
        return [];
      }
      const error = validations.validateMinMax(t, field.get('label', field.get('name')), value, min, max);
      return error ? [error] : [];
    });
    /**
     * In case the `onChangeObject` function is frozen by a child widget implementation,
     * e.g. when debounced, always get the latest object value instead of using
     * `this.props.value` directly.
     */
    _defineProperty(this, "getObjectValue", idx => this.props.value.get(idx) || Map());
    _defineProperty(this, "handleChangeFor", memoize(index => {
      return (f, newValue, newMetadata) => {
        const {
          value,
          metadata,
          onChange,
          field
        } = this.props;
        const collectionName = field.get('name');
        const listFieldObjectWidget = field.getIn(['field', 'widget']) === 'object';
        const withNameKey = this.getValueType() !== valueTypes.SINGLE || this.getValueType() === valueTypes.SINGLE && listFieldObjectWidget;
        const newObjectValue = withNameKey ? this.getObjectValue(index).set(f.get('name'), newValue) : newValue;
        const parsedMetadata = {
          [collectionName]: Object.assign(metadata ? metadata.toJS() : {}, newMetadata || {})
        };
        onChange(value.set(index, newObjectValue), parsedMetadata);
      };
    }));
    _defineProperty(this, "handleRemove", (index, event) => {
      event.preventDefault();
      const {
        itemsCollapsed
      } = this.state;
      const {
        value,
        metadata,
        onChange,
        field,
        clearFieldErrors,
        onValidateObject,
        forID,
        fieldsErrors
      } = this.props;
      const collectionName = field.get('name');
      const isSingleField = this.getValueType() === valueTypes.SINGLE;
      const metadataRemovePath = isSingleField ? value.get(index) : value.get(index).valueSeq();
      const parsedMetadata = metadata && !metadata.isEmpty() ? {
        [collectionName]: metadata.removeIn(metadataRemovePath)
      } : metadata;

      // Get the key of the item being removed
      const removedKey = this.state.keys[index];

      // Update state while preserving keys for remaining items
      const newKeys = [...this.state.keys];
      newKeys.splice(index, 1);
      itemsCollapsed.splice(index, 1);
      this.setState({
        itemsCollapsed: [...itemsCollapsed],
        keys: newKeys
      });

      // Clear the ref for the removed item
      delete this.childRefs[removedKey];
      const newValue = value.delete(index);

      // Clear errors for the removed item and its children
      if (fieldsErrors) {
        Object.entries(fieldsErrors.toJS()).forEach(([fieldId, errors]) => {
          if (errors.some(err => {
            var _err$parentIds;
            return (_err$parentIds = err.parentIds) === null || _err$parentIds === void 0 ? void 0 : _err$parentIds.includes(removedKey);
          })) {
            clearFieldErrors(fieldId);
          }
        });
      }

      // If list is empty, mark it as valid
      if (newValue.size === 0) {
        clearFieldErrors(forID);
        onValidateObject(forID, []);
      }

      // Update the value last to ensure all error states are cleared
      onChange(newValue, parsedMetadata);
    });
    _defineProperty(this, "handleItemCollapseToggle", (index, event) => {
      event.preventDefault();
      const {
        itemsCollapsed
      } = this.state;
      const newItemsCollapsed = itemsCollapsed.map((collapsed, itemIndex) => {
        if (index === itemIndex) {
          return !collapsed;
        }
        return collapsed;
      });
      this.setState({
        itemsCollapsed: newItemsCollapsed
      });
    });
    _defineProperty(this, "handleCollapseAllToggle", e => {
      e.preventDefault();
      const {
        value,
        field
      } = this.props;
      const {
        itemsCollapsed,
        listCollapsed
      } = this.state;
      const minimizeCollapsedItems = field.get('minimize_collapsed', false);
      const listCollapsedByDefault = field.get('collapsed', true);
      const allItemsCollapsed = itemsCollapsed.every(val => val === true);
      if (minimizeCollapsedItems) {
        let updatedItemsCollapsed = itemsCollapsed;
        // Only allow collapsing all items in this mode but not opening all at once
        if (!listCollapsed || !listCollapsedByDefault) {
          updatedItemsCollapsed = Array(value.size).fill(!listCollapsed);
        }
        this.setState({
          listCollapsed: !listCollapsed,
          itemsCollapsed: updatedItemsCollapsed
        });
      } else {
        this.setState({
          itemsCollapsed: Array(value.size).fill(!allItemsCollapsed)
        });
      }
    });
    _defineProperty(this, "onSortEnd", ({
      oldIndex,
      newIndex
    }) => {
      const {
        value,
        clearFieldErrors
      } = this.props;
      const {
        itemsCollapsed,
        keys
      } = this.state;

      // Update value
      const item = value.get(oldIndex);
      const newValue = value.delete(oldIndex).insert(newIndex, item);
      this.props.onChange(newValue);

      // Update collapsing
      const collapsed = itemsCollapsed[oldIndex];
      itemsCollapsed.splice(oldIndex, 1);
      const updatedItemsCollapsed = [...itemsCollapsed];
      updatedItemsCollapsed.splice(newIndex, 0, collapsed);

      // Reset item to ensure updated state
      const updatedKeys = keys.map((key, keyIndex) => {
        if (keyIndex === oldIndex || keyIndex === newIndex) {
          return uuid();
        }
        return key;
      });
      this.setState({
        itemsCollapsed: updatedItemsCollapsed,
        keys: updatedKeys
      });

      //clear error fields and remove old validations
      clearFieldErrors();
      this.validations = this.validations.filter(item => updatedKeys.includes(item.key));
    });
    _defineProperty(this, "hasError", index => {
      const {
        fieldsErrors
      } = this.props;
      if (fieldsErrors && fieldsErrors.size > 0) {
        return Object.values(fieldsErrors.toJS()).some(arr => arr.some(err => err.parentIds && err.parentIds.includes(this.state.keys[index])));
      }
    });
    _defineProperty(this, "getStableParentIds", memoize((parentIds, forID, key) => [...parentIds, forID, key], (parentIds, forID, key) => JSON.stringify([...parentIds, forID, key])));
    // eslint-disable-next-line react/display-name
    _defineProperty(this, "renderField", (item, index) => {
      const {
        editorControl: EditorControl,
        onValidateObject,
        metadata,
        clearFieldErrors,
        fieldsErrors,
        controlRef,
        parentIds,
        forID,
        theme
      } = this.props;
      const {
        keys
      } = this.state;
      const key = keys[index];
      let field = this.props.field;
      const hasError = this.hasError(index);
      const isVariableTypesList = this.getValueType() === valueTypes.MIXED;
      if (isVariableTypesList) {
        field = getTypedFieldForValue(field, item);
        if (!field) {
          return this.renderErroneousTypedItem(index, item);
        }
      }
      return ___EmotionJSX(EditorControl, {
        key: key,
        field: field,
        value: item,
        onChange: this.handleChangeFor(index),
        metadata: metadata,
        forList: true,
        onValidate: onValidateObject,
        clearFieldErrors: clearFieldErrors,
        fieldsErrors: fieldsErrors
        // ref={this.processControlRef}
        // controlRef={controlRef}
        ,
        validationKey: key,
        "data-testid": `object-control-${key}`,
        hasError: hasError,
        parentIds: this.getStableParentIds(parentIds, forID, key),
        theme: theme
      });
    });
    const {
      value: _value
    } = props;
    const _keys = _value && Array.from({
      length: _value.size
    }, () => uuid()) || [];
    this.state = {
      value: this.valueToString(_value),
      keys: _keys
    };
    console.log('ListControl props', this.props);
    console.log('ListControl state', this.state);
  }
  getListFieldDescription(item) {
    const {
      field,
      entry
    } = this.props;
    const valueType = this.getValueType();
    switch (valueType) {
      case valueTypes.MIXED:
        {
          if (!validateItem(field, item)) {
            return;
          }
          const itemType = getTypedFieldForValue(field, item);
          const label = itemType.get('label', itemType.get('name'));
          // each type can have its own summary, but default to the list summary if exists
          const summary = itemType.get('summary', field.get('summary'));
          const labelReturn = summary ? handleSummary(summary, entry, label, item) : label;
          return labelReturn;
        }
      case valueTypes.SINGLE:
        {
          const singleField = field.get('field');
          const label = singleField.get('label', singleField.get('name'));
          const summary = field.get('summary');
          const data = fromJS({
            [singleField.get('name')]: item
          });
          const labelReturn = summary ? handleSummary(summary, entry, label, data) : label;
          return labelReturn;
        }
      case valueTypes.MULTIPLE:
        {
          if (!validateItem(field, item)) {
            return;
          }
          const multiFields = field.get('fields');
          const labelField = multiFields && multiFields.first();
          const value = item.get(labelField.get('name'));
          const summary = field.get('summary');
          const labelReturn = summary ? handleSummary(summary, entry, value, item) : value;
          return (labelReturn || `No ${labelField.get('name')}`).toString();
        }
    }
    return '';
  }
  renderListControl() {
    const {
      value,
      field
    } = this.props;
    const {
      keys
    } = this.state;
    const items = value || List();
    const labelSingular = field.get('label_singular') || field.get('label', field.get('name'));
    return ___EmotionJSX(ListField, {
      labelSingular: labelSingular,
      items: items,
      keys: keys,
      renderDescription: item => this.getListFieldDescription(item),
      renderFields: this.renderField,
      onAdd: this.handleAdd,
      onAddType: type => this.handleAddType(type, resolveFieldKeyType(field)),
      onReorder: this.onSortEnd
    });
  }
  renderInput() {
    const {
      forID,
      classNameWrapper
    } = this.props;
    const {
      value
    } = this.state;
    return ___EmotionJSX("input", {
      type: "text",
      id: forID,
      value: value,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      className: classNameWrapper
    });
  }
  render() {
    if (this.getValueType() !== null) {
      return this.renderListControl();
    } else {
      return this.renderInput();
    }
  }
}
_defineProperty(ListControl, "propTypes", {
  metadata: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  onChangeObject: PropTypes.func.isRequired,
  onValidateObject: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  value: ImmutablePropTypes.list,
  field: PropTypes.object,
  forID: PropTypes.string,
  controlRef: PropTypes.func,
  mediaPaths: ImmutablePropTypes.map.isRequired,
  getAsset: PropTypes.func.isRequired,
  onOpenMediaLibrary: PropTypes.func.isRequired,
  onAddAsset: PropTypes.func.isRequired,
  onRemoveInsertedMedia: PropTypes.func.isRequired,
  classNameWrapper: PropTypes.string.isRequired,
  setActiveStyle: PropTypes.func.isRequired,
  setInactiveStyle: PropTypes.func.isRequired,
  editorControl: PropTypes.elementType.isRequired,
  resolveWidget: PropTypes.func.isRequired,
  clearFieldErrors: PropTypes.func.isRequired,
  fieldsErrors: ImmutablePropTypes.map.isRequired,
  entry: ImmutablePropTypes.map.isRequired,
  t: PropTypes.func
});
_defineProperty(ListControl, "defaultProps", {
  value: List(),
  parentIds: []
});